import type { ContactMessageItem } from "@/lib/gql/__generated__/graphql";

import { Image } from "@/components/ui/image/image";

import { FromNowText, MessageAndImages } from "../_components";

type Props = {
	message: ContactMessageItem;
};

export const AdminMessage = ({ message }: Props) => {
	return (
		<div className="flex justify-start">
			<div className="flex flex-col gap-y-2">
				<FromNowText createdAt={message.createdAt} />

				<div className="flex items-start gap-x-4">
					<div>
						<Image
							src="/chillnn-logo-black.png"
							className="aspect-square rounded-full border border-zinc-200 bg-white object-contain"
							width={48}
							height={48}
						/>
					</div>

					<div className="w-1/2 rounded-b-xl rounded-tr-xl bg-zinc-100 p-4">
						<MessageAndImages message={message.message} images={message.images} />
					</div>
				</div>
			</div>
		</div>
	);
};

AdminMessage.displayName = "AdminMessage";
